/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 11:19 AM
 *
 */

import { Controller } from 'react-hook-form';
import Select from 'react-select';

type DropdownProps = {
  name: string;
  label: string;
  control: any;
  options: Array<any>;
  isDisabled?: boolean;
  noOptionMessage?: string;
};

const DropdownController = ({
  name,
  label,
  control,
  options,
  isDisabled,
  noOptionMessage = 'No Options Found',
}: DropdownProps) => {
  const customStyles: any = {
    option: (provided: any, state: any) => ({
      ...provided,
      color: 'gray',
      background: state.isFocused ? '#dcfce7' : 'white',
      padding: '0.4rem 1.5rem',
      cursor: 'pointer',
      textTransform: 'capitalize',
      zIndex: 100,
    }),

    valueContainer: (provide: any) => ({
      ...provide,
      padding: 0,
    }),

    indicatorSeparator: () => ({
      padding: 0,
      color: '#d4d4d4',
    }),

    dropdownIndicator: () => ({
      padding: 0,
      width: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '16px',
      color: '#525252',
      cursor: 'pointer',
    }),
    indicatorsContainer: (provide: any) => ({
      ...provide,
      padding: 0,
    }),
    input: (provide: any) => ({
      ...provide,
      padding: '0',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      padding: '0',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: 'rgb(115 115 115)',
    }),
    control: () => ({
      background: 'white',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      borderRadius: '0.375rem',
      border: 'solid rgb(229 229 229) 1px ',
      borderBottom: 'solid rgb(34 197 94) 1px',
      padding: '1.25rem 1.5rem',
      color: 'rgb(82 82 82)',
      fontSize: '1.125rem',
      textTransform: 'capitalize',
    }),
  };

  return (
    <div className="z-[100]">
      {label && <label className="input_label">{label}</label>}

      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value, ref } }) => (
          <Select
            isDisabled={isDisabled}
            key={`my_unique_select_key__${value}`}
            ref={ref}
            placeholder="Choose"
            options={options}
            value={options.find((c) => c.value === value)}
            onChange={(val: any) => {
              onChange(val.value);
            }}
            isSearchable={true}
            styles={customStyles}
            noOptionsMessage={({ inputValue }) =>
              !inputValue ? noOptionMessage : 'No results found'
            }
          />
        )}
      />
    </div>
  );
};

export default DropdownController;
